"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const avatars_1 = require("gridy-avatars/dist/avatars");
function default_1(options = {}) {
    return function (random) {
        let body = random.integer(0, 7);
        let bodyColor = random.integer(0, 7);
        let eyes = random.integer(0, 7);
        let eyesColor = random.integer(0, 7);
        let mouth = random.integer(0, 7);
        let mouthColor = options.colorful ? random.integer(0, 7) : eyesColor;
        return [
            '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="isolation:isolate" viewBox="0 0 24 24" version="1.1">',
            avatars_1.inner(`${body}${bodyColor}${eyes}${eyesColor}${mouth}${mouthColor}`),
            '</svg>'
        ].join('');
    };
}
exports.default = default_1;
//# sourceMappingURL=index.js.map